import { tableV2BodyRowHeightPx } from '@/features/shared/components/tableSystem/TableV2Constants';

export const tableV2RenderedDividerHeightPx = 0.5;

export const resolveTableV2BodyRowHeight = (_hasRenderedDivider: boolean): string =>
  `${String(tableV2BodyRowHeightPx)}px`;

export const resolveTableV2BodyRowsHeight = (rowCount: number): string => {
  const bodyHeight = rowCount * tableV2BodyRowHeightPx;
  return `${String(bodyHeight)}px`;
};

export const resolveTableV2SkeletonRowHeight = ({
  isLastVisibleRow: _isLastVisibleRow,
  showLastDivider: _showLastDivider = false,
}: {
  isLastVisibleRow: boolean;
  showLastDivider?: boolean;
}): string => resolveTableV2BodyRowHeight(false);
